import React, { ReactElement } from 'react';

import * as S from './InstallationInstructions.styles';

export const InstallationInstructions = (): ReactElement => {
  return (
    <S.Wrapper>
      <S.Content>
        <S.Title>Installation instructions</S.Title>

        <S.List>
          <S.Item>
            <S.Step>1</S.Step>
            <div>
              <S.Text>Download & Install</S.Text>
              <S.Description>
                Download the file to your Mac, open the installer, and follow the instructions.
              </S.Description>
            </div>
          </S.Item>

          <S.Item>
            <S.Step>2</S.Step>
            <div>
              <S.Text>Open Brain.fm</S.Text>
              <S.Description>
                Open the newly installed app from your Applications folder.
              </S.Description>
            </div>
          </S.Item>

          <S.Item>
            <S.Step>3</S.Step>
            <div>
              <S.Text>Pair your account</S.Text>
              <S.Description>
                Follow the in-app directions to pair your Brain.fm account.
              </S.Description>
            </div>
          </S.Item>
        </S.List>
      </S.Content>
    </S.Wrapper>
  );
};
